// This function allow to reference all chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "" + {"15":"sv","228":"tidau","532":"styles"}[chunkId] + "." + {"15":"95306ae2ffb0473d7a24","228":"db7d03b8cd7533e417dd","532":"a5ab9d86a4b48692e86e"}[chunkId] + ".css";
};